<template>
  <div>
    <!-- 配送单拆分 -->
    <el-dialog :title="$t('message.distributionOrderSplitting')" :close-on-click-modal="false"
      :visible.sync="$parent.distributionOrderSplittingDialogVisible" width="1232px" center>
      <div class="table">
        <ol>
          <!--  NO-->
          <li class="flex05">NO</li>
          <!--  订单号-->
          <li class="flex15">{{ $t("message.orderNumber") }}</li>
          <!--  番号-->
          <li class="flex05">{{ $t("message.mash") }}</li>
          <!--  照片-->
          <li>{{ $t("message.pic") }}</li>
          <!--  业务编辑商品属性-->
          <li class="flex15">
            {{ $t("message.theBusinessEditsTheCommodityProperties") }}
          </li>
          <!--  数量-->
          <li>{{ $t("message.quantity") }}</li>
          <!--  拆分到新配送单数-->
          <li>{{ $t("message.splitToNewDeliverySingular") }}</li>
          <!--  剩余数量-->
          <li>{{ $t("message.surplusQuantity") }}</li>
        </ol>
        <ul v-for="(item, index) in selectedList" :key="index">
          <!--  NO-->
          <li class="flex05">{{ index + 1 }}</li>
          <!--  订单号-->
          <li class="flex15">{{ item.order_sn }}</li>
          <!--  番号-->
          <li class="flex05">{{ item.sorting }}</li>
          <!--  照片-->
          <li>
            <el-popover placement="right" width="300" trigger="hover">
              <img :src="item.pic" alt="" style="width: 300px; height: 300px" />
              <a href="JavaScript:;" slot="reference">
                <el-image :src="item.pic" style="width: 60px; height: 60px; border-radius: 4px">
                  <div slot="placeholder" class="image-slot">
                    加载中<span class="dot">...</span>
                  </div>
                </el-image>
              </a>
            </el-popover>
          </li>
          <!--  业务编辑商品属性-->
          <li class="flex15">
            <div class="attribute">
              <el-tooltip placement="bottom">
                <div slot="content">
                  <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex"
                    style="margin-bottom: 5px">
                    {{ itemDetail.key }}：{{ itemDetail.value }}
                  </div>
                </div>
                <div>
                  <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex">
                    {{ itemDetail.key }}：{{ itemDetail.value }}
                  </div>
                </div>
              </el-tooltip>
            </div>
          </li>
          <!--  数量-->
          <li>
            <div class="template">
              <!-- 提出数 -->
              <p>{{ $t("message.putForwardNum") }}：{{ item.num }}</p>
              <!-- 待装箱 -->
              <p>
                {{ $t("message.toEncasement") }}：{{ item.wait_freight_num }}
              </p>
              <!-- 已装箱 -->
              <p>{{ $t("message.boxed") }}：{{ item.freight_num }}</p>
              <!-- 已出货 -->
              <p>{{ $t("message.shipped") }}：{{ item.delivery_num }}</p>
            </div>
          </li>
          <!--  拆分到新配送单数-->
          <li>
            <el-input v-model="item.splitNum" type="number" @input="maxNum(index, item)"></el-input>
          </li>
          <!--  剩余数量-->
          <li>
            {{ item.num - item.splitNum == NaN ? 0 : item.num - item.splitNum }}
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="foot">
          <p class="fl">
            提示：拆分后新配送单人员默认和当前配送单一样，有需要调整的请到进行中配送单界面调整
          </p>
          <!-- 保存 -->
          <el-button type="primary" @click="save" class="fr">
            {{ $t("message.save") }}
          </el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    selectedList: { type: Array },
  },
  data() {
    return {
      porder_sn: this.$route.query.porder_sn,
    };
  },
  methods: {
    // 保存
    save() {
      let datas = {
        list: [],
      };
      for (let i = 0; i < this.selectedList.length; i++) {
        if (this.selectedList[i].splitNum > 0) {
          datas.list.push({
            porder_detail_id: this.selectedList[i].id,
            num: this.selectedList[i].splitNum,
          });
        }
      }
      this.$api.porderApi.splitPorderTranslate(datas).then((res) => {
        this.$message.success(res.msg);
        this.$parent.distributionOrderSplittingDialogVisible = false;
        this.$store.dispatch("porderDetail", { porder_sn: this.porder_sn });
      });
    },
    // 最大数
    maxNum(i, item) {
      if (item.splitNum > item.num) {
        this.selectedList[i].splitNum = item.num;
        this.$forceUpdate();
        this.$message.error("拆分数不能大于提出数");
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.table {
  margin: 0px 15px;

  background-color: #f8f8f8;
  padding: 24px;
  border-radius: 8px;

  .flex05 {
    flex: 0.5;
  }

  .flex15 {
    flex: 1.5;
  }
}

.foot {
  overflow: hidden;
  margin: 0px 20px;

  p {
    color: #fa5058;
    line-height: 40px;
  }
}
</style>